import * as type from './actionTypes';

// Audio Abbreviation
export const setAllAudioAbbreviations = (abbreviations) => ({
  type: type.SET_ALL_AUDIO_ABBREVIATIONS,
  payload: {
    abbreviations,
  },
});

export const clearAudioAbbreviations = () => ({
  type: type.CLEAR_AUDIO_ABBREVIATIONS,
});
